import { Vue, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component
export default class ProjectMenuFlag extends Vue {
  @Prop() flagLocation: string;

  public getLocation() {
    if (this.flagLocation) return this.flagLocation.toLocaleLowerCase();
  }
}
